const answers = {
  "2025-12-24": "about",
  "2025-12-25": "bread",
  "2025-12-26": "chair",
  "2025-12-27": "dream",
  "2025-12-28": "early",
  "2025-12-29": "field",
  "2025-12-30": "glass",
  "2025-12-31": "happy",
  "2026-01-01": "ideal",
  "2026-01-02": "jolly",
  "2026-01-03": "knife",
  "2026-01-04": "laugh",
  "2026-01-05": "music",
  "2026-01-06": "north",
  "2026-01-07": "ocean",
  "2026-01-08": "peace",
  "2026-01-09": "quick",
  "2026-01-10": "ready",
  "2026-01-11": "smart",
  "2026-01-12": "train",
  "2026-01-13": "reedy",
  "2026-01-14": "beefy",
  "2026-01-15": "hardy",
  "2026-01-16": "frank",
  "2026-01-17": "birch",
  "2026-01-18": "scrap",
  "2026-01-19": "sonar",
  "2026-01-20": "embed",
  "2026-01-21": "froze",
  "2026-01-22": "basis",
  "2026-01-23": "loamy",
  "2026-01-24": "valve",
  "2026-01-25": "outdo",
  "2026-01-26": "pence",
  "2026-01-27": "savvy",
  "2026-01-28": "satin",
  "2026-01-29": "depot",
  "2026-01-30": "slash",
  "2026-01-31": "wrong",
  "2026-02-01": "ahead",
  "2026-02-02": "label",
  "2026-02-03": "perky",
  "2026-02-04": "bagel",
  "2026-02-05": "cruel",
  "2026-02-06": "blaze",
  "2026-02-07": "stony",
  "2026-02-08": "grimy",
  "2026-02-09": "hymen",
  "2026-02-10": "caput",
  "2026-02-11": "fraud",
  "2026-02-12": "grope",
  "2026-02-13": "woody",
  "2026-02-14": "gaunt",
  "2026-02-15": "queen",
  "2026-02-16": "aisle",
  "2026-02-17": "butte",
  "2026-02-18": "price",
  "2026-02-19": "tripe",
  "2026-02-20": "shady",
  "2026-02-21": "humor",
  "2026-02-22": "pique",
  "2026-02-23": "ruder",
  "2026-02-24": "float",
  "2026-02-25": "ralph",
  "2026-02-26": "scoff",
  "2026-02-27": "yield",
  "2026-02-28": "rinse",
  "2026-03-01": "dried",
  "2026-03-02": "amend",
  "2026-03-03": "widen",
  "2026-03-04": "grand",
  "2026-03-05": "theft",
  "2026-03-06": "chaos",
  "2026-03-07": "swell",
  "2026-03-08": "torus",
  "2026-03-09": "comma",
  "2026-03-10": "spiny",
  "2026-03-11": "point",
  "2026-03-12": "quota",
  "2026-03-13": "clean",
  "2026-03-14": "knelt",
  "2026-03-15": "vodka",
  "2026-03-16": "ardor",
  "2026-03-17": "noble",
  "2026-03-18": "tenth",
  "2026-03-19": "corny",
  "2026-03-20": "unset",
  "2026-03-21": "delve",
  "2026-03-22": "briar",
  "2026-03-23": "agate",
  "2026-03-24": "wider",
  "2026-03-25": "buddy",
  "2026-03-26": "bless",
  "2026-03-27": "waxen",
  "2026-03-28": "munch",
  "2026-03-29": "bossy",
  "2026-03-30": "resin",
  "2026-03-31": "elide",
  "2026-04-01": "fishy",
  "2026-04-02": "crown",
  "2026-04-03": "snarl",
  "2026-04-04": "phony",
  "2026-04-05": "tough",
  "2026-04-06": "swish",
  "2026-04-07": "drawl",
  "2026-04-08": "booby",
  "2026-04-09": "stout",
  "2026-04-10": "joint",
  "2026-04-11": "heave",
  "2026-04-12": "labor",
  "2026-04-13": "freer",
  "2026-04-14": "ovoid",
  "2026-04-15": "batch",
  "2026-04-16": "seize",
  "2026-04-17": "recut",
  "2026-04-18": "swarm",
  "2026-04-19": "proxy",
  "2026-04-20": "debar",
  "2026-04-21": "scold",
  "2026-04-22": "rebut",
  "2026-04-23": "bluff",
  "2026-04-24": "annex",
  "2026-04-25": "arose",
  "2026-04-26": "whiny",
  "2026-04-27": "pasty",
  "2026-04-28": "lurid",
  "2026-04-29": "rebus",
  "2026-04-30": "style",
  "2026-05-01": "smear",
  "2026-05-02": "waive",
  "2026-05-03": "lousy",
  "2026-05-04": "whine",
  "2026-05-05": "month",
  "2026-05-06": "gruff",
  "2026-05-07": "scaly",
  "2026-05-08": "lapel",
  "2026-05-09": "still",
  "2026-05-10": "piggy",
  "2026-05-11": "aping",
  "2026-05-12": "grief",
  "2026-05-13": "aphid",
  "2026-05-14": "mummy",
  "2026-05-15": "rifle",
  "2026-05-16": "minim",
  "2026-05-17": "incur",
  "2026-05-18": "thumb",
  "2026-05-19": "moral",
  "2026-05-20": "genre",
  "2026-05-21": "click",
  "2026-05-22": "zebra",
  "2026-05-23": "twirl",
  "2026-05-24": "tidal",
  "2026-05-25": "safer",
  "2026-05-26": "serum",
  "2026-05-27": "flute",
  "2026-05-28": "yacht",
  "2026-05-29": "usurp",
  "2026-05-30": "total",
  "2026-05-31": "sumac",
  "2026-06-01": "dummy",
  "2026-06-02": "blush",
  "2026-06-03": "alive",
  "2026-06-04": "bongo",
  "2026-06-05": "hover",
  "2026-06-06": "aging",
  "2026-06-07": "reign",
  "2026-06-08": "triad",
  "2026-06-09": "aback",
  "2026-06-10": "rebar",
  "2026-06-11": "crush",
  "2026-06-12": "below",
  "2026-06-13": "madam",
  "2026-06-14": "chose",
  "2026-06-15": "aroma",
  "2026-06-16": "tulip",
  "2026-06-17": "rotor",
  "2026-06-18": "meaty",
  "2026-06-19": "sperm",
  "2026-06-20": "earth",
  "2026-06-21": "flame",
  "2026-06-22": "upset",
  "2026-06-23": "flare",
  "2026-06-24": "gauge",
  "2026-06-25": "ratio",
  "2026-06-26": "glare",
  "2026-06-27": "comfy",
  "2026-06-28": "endow",
  "2026-06-29": "beget",
  "2026-06-30": "nerdy",
  "2026-07-01": "emcee",
  "2026-07-02": "night",
  "2026-07-03": "hefty",
  "2026-07-04": "nurse",
  "2026-07-05": "awake",
  "2026-07-06": "shout",
  "2026-07-07": "eying",
  "2026-07-08": "lucky",
  "2026-07-09": "dryer",
  "2026-07-10": "trace",
  "2026-07-11": "bused",
  "2026-07-12": "ulcer",
  "2026-07-13": "forte",
  "2026-07-14": "gaily",
  "2026-07-15": "hutch",
  "2026-07-16": "crock",
  "2026-07-17": "viral",
  "2026-07-18": "hello",
  "2026-07-19": "burnt",
  "2026-07-20": "harpy",
  "2026-07-21": "sniff",
  "2026-07-22": "badge",
  "2026-07-23": "sauna",
  "2026-07-24": "retry",
  "2026-07-25": "dwell",
  "2026-07-26": "fugue",
  "2026-07-27": "fatal",
  "2026-07-28": "dutch",
  "2026-07-29": "vocal",
  "2026-07-30": "taffy",
  "2026-07-31": "spoil",
  "2026-08-01": "jerky",
  "2026-08-02": "strut",
  "2026-08-03": "surer",
  "2026-08-04": "utter",
  "2026-08-05": "globe",
  "2026-08-06": "shalt",
  "2026-08-07": "wield",
  "2026-08-08": "grant",
  "2026-08-09": "would",
  "2026-08-10": "plank",
  "2026-08-11": "twist",
  "2026-08-12": "stall",
  "2026-08-13": "mania",
  "2026-08-14": "optic",
  "2026-08-15": "femur",
  "2026-08-16": "tuber",
  "2026-08-17": "twixt",
  "2026-08-18": "dress",
  "2026-08-19": "micro",
  "2026-08-20": "heard",
  "2026-08-21": "route",
  "2026-08-22": "model",
  "2026-08-23": "molar",
  "2026-08-24": "taken",
  "2026-08-25": "argue",
  "2026-08-26": "their",
  "2026-08-27": "setup",
  "2026-08-28": "udder",
  "2026-08-29": "stead",
  "2026-08-30": "probe",
  "2026-08-31": "sound",
  "2026-09-01": "golem",
  "2026-09-02": "gouge",
  "2026-09-03": "robin",
  "2026-09-04": "stern",
  "2026-09-05": "booze",
  "2026-09-06": "often",
  "2026-09-07": "write",
  "2026-09-08": "guess",
  "2026-09-09": "giver",
  "2026-09-10": "teach",
  "2026-09-11": "hippo",
  "2026-09-12": "wrote",
  "2026-09-13": "chock",
  "2026-09-14": "graph",
  "2026-09-15": "apply",
  "2026-09-16": "grass",
  "2026-09-17": "taper",
  "2026-09-18": "nudge",
  "2026-09-19": "clasp",
  "2026-09-20": "steed",
  "2026-09-21": "mossy",
  "2026-09-22": "atoll",
  "2026-09-23": "roger",
  "2026-09-24": "abort",
  "2026-09-25": "guard",
  "2026-09-26": "shall",
  "2026-09-27": "aloft",
  "2026-09-28": "clink",
  "2026-09-29": "mimic",
  "2026-09-30": "flake",
  "2026-10-01": "chasm",
  "2026-10-02": "tubal",
  "2026-10-03": "forty",
  "2026-10-04": "motel",
  "2026-10-05": "witch",
  "2026-10-06": "loyal",
  "2026-10-07": "drown",
  "2026-10-08": "afoot",
  "2026-10-09": "braid",
  "2026-10-10": "crisp",
  "2026-10-11": "choir",
  "2026-10-12": "clone",
  "2026-10-13": "catch",
  "2026-10-14": "leant",
  "2026-10-15": "death",
  "2026-10-16": "copse",
  "2026-10-17": "daily",
  "2026-10-18": "vapid",
  "2026-10-19": "sneak",
  "2026-10-20": "ramen",
  "2026-10-21": "bezel",
  "2026-10-22": "awash",
  "2026-10-23": "baron",
  "2026-10-24": "cough",
  "2026-10-25": "abuse",
  "2026-10-26": "chord",
  "2026-10-27": "orbit",
  "2026-10-28": "lager",
  "2026-10-29": "curio",
  "2026-10-30": "oxide",
  "2026-10-31": "above",
  "2026-11-01": "musky",
  "2026-11-02": "meant",
  "2026-11-03": "frill",
  "2026-11-04": "kneel",
  "2026-11-05": "bevel",
  "2026-11-06": "clung",
  "2026-11-07": "swath",
  "2026-11-08": "mount",
  "2026-11-09": "await",
  "2026-11-10": "prose",
  "2026-11-11": "mucus",
  "2026-11-12": "bicep",
  "2026-11-13": "heist",
  "2026-11-14": "blink",
  "2026-11-15": "musty",
  "2026-11-16": "purse",
  "2026-11-17": "beach",
  "2026-11-18": "blind",
  "2026-11-19": "theta",
  "2026-11-20": "denim",
  "2026-11-21": "quart",
  "2026-11-22": "thank",
  "2026-11-23": "grunt",
  "2026-11-24": "dozen",
  "2026-11-25": "snipe",
  "2026-11-26": "lemon",
  "2026-11-27": "semen",
  "2026-11-28": "roomy",
  "2026-11-29": "mouse",
  "2026-11-30": "marsh",
  "2026-12-01": "talon",
  "2026-12-02": "scalp",
  "2026-12-03": "batty",
  "2026-12-04": "phase",
  "2026-12-05": "hunch",
  "2026-12-06": "lemur",
  "2026-12-07": "amble",
  "2026-12-08": "magma",
  "2026-12-09": "tweak",
  "2026-12-10": "motif",
  "2026-12-11": "rigid",
  "2026-12-12": "rodeo",
  "2026-12-13": "truck",
  "2026-12-14": "spray",
  "2026-12-15": "tribe",
  "2026-12-16": "sunny",
  "2026-12-17": "spree",
  "2026-12-18": "tatty",
  "2026-12-19": "troop",
  "2026-12-20": "shave",
  "2026-12-21": "atone",
  "2026-12-22": "pinto",
  "2026-12-23": "union",
  "2026-12-24": "vapor",
  "2026-12-25": "leach",
  "2026-12-26": "paper",
  "2026-12-27": "macho",
  "2026-12-28": "metal",
  "2026-12-29": "worry",
  "2026-12-30": "broom",
  "2026-12-31": "grime",
  "2027-01-01": "stove",
  "2027-01-02": "brood",
  "2027-01-03": "crony",
  "2027-01-04": "tenor",
  "2027-01-05": "elate",
  "2027-01-06": "glade",
  "2027-01-07": "torso",
  "2027-01-08": "fancy",
  "2027-01-09": "skull",
  "2027-01-10": "tying",
  "2027-01-11": "steer",
  "2027-01-12": "tasty",
  "2027-01-13": "slump",
  "2027-01-14": "afire",
  "2027-01-15": "alter",
  "2027-01-16": "puppy",
  "2027-01-17": "reuse",
  "2027-01-18": "trope",
  "2027-01-19": "owner",
  "2027-01-20": "girth",
  "2027-01-21": "demon",
  "2027-01-22": "morph",
  "2027-01-23": "carol",
  "2027-01-24": "welsh",
  "2027-01-25": "jetty",
  "2027-01-26": "demur",
  "2027-01-27": "sleek",
  "2027-01-28": "spill",
  "2027-01-29": "kappa",
  "2027-01-30": "album",
  "2027-01-31": "daddy",
  "2027-02-01": "crumb",
  "2027-02-02": "testy",
  "2027-02-03": "filer",
  "2027-02-04": "scree",
  "2027-02-05": "among",
  "2027-02-06": "siege",
  "2027-02-07": "begat",
  "2027-02-08": "conch",
  "2027-02-09": "medal",
  "2027-02-10": "skirt",
  "2027-02-11": "splat",
  "2027-02-12": "photo",
  "2027-02-13": "risky",
  "2027-02-14": "cutie",
  "2027-02-15": "steep",
  "2027-02-16": "these",
  "2027-02-17": "coast",
  "2027-02-18": "snowy",
  "2027-02-19": "weary",
  "2027-02-20": "shrew",
  "2027-02-21": "frown",
  "2027-02-22": "sedan",
  "2027-02-23": "shape",
  "2027-02-24": "spiky",
  "2027-02-25": "quell",
  "2027-02-26": "segue",
  "2027-02-27": "uncut",
  "2027-02-28": "fable",
  "2027-03-01": "exert",
  "2027-03-02": "trout",
  "2027-03-03": "eerie",
  "2027-03-04": "inter",
  "2027-03-05": "gnome",
  "2027-03-06": "enter",
  "2027-03-07": "glean",
  "2027-03-08": "stuck",
  "2027-03-09": "sauce",
  "2027-03-10": "pried",
  "2027-03-11": "nylon",
  "2027-03-12": "slang",
  "2027-03-13": "eager",
  "2027-03-14": "scrum",
  "2027-03-15": "sappy",
  "2027-03-16": "money",
  "2027-03-17": "hydro",
  "2027-03-18": "false",
  "2027-03-19": "wryly",
  "2027-03-20": "feast",
  "2027-03-21": "penny",
  "2027-03-22": "steam",
  "2027-03-23": "covey",
  "2027-03-24": "liken",
  "2027-03-25": "salty",
  "2027-03-26": "bilge",
  "2027-03-27": "patty",
  "2027-03-28": "track",
  "2027-03-29": "enemy",
  "2027-03-30": "sushi",
  "2027-03-31": "trunk",
  "2027-04-01": "maxim",
  "2027-04-02": "manga",
  "2027-04-03": "duchy",
  "2027-04-04": "trial",
  "2027-04-05": "nosey",
  "2027-04-06": "vivid",
  "2027-04-07": "leech",
  "2027-04-08": "icily",
  "2027-04-09": "prove",
  "2027-04-10": "botch",
  "2027-04-11": "round",
  "2027-04-12": "sworn",
  "2027-04-13": "gayly",
  "2027-04-14": "sense",
  "2027-04-15": "title",
  "2027-04-16": "whale",
  "2027-04-17": "unzip",
  "2027-04-18": "quasi",
  "2027-04-19": "erase",
  "2027-04-20": "smelt",
  "2027-04-21": "opine",
  "2027-04-22": "aunty",
  "2027-04-23": "butch",
  "2027-04-24": "bathe",
  "2027-04-25": "email",
  "2027-04-26": "towel",
  "2027-04-27": "drawn",
  "2027-04-28": "circa",
  "2027-04-29": "banjo",
  "2027-04-30": "valet",
  "2027-05-01": "trend",
  "2027-05-02": "shied",
  "2027-05-03": "cheek",
  "2027-05-04": "stoop",
  "2027-05-05": "muddy",
  "2027-05-06": "drain",
  "2027-05-07": "baggy",
  "2027-05-08": "moldy",
  "2027-05-09": "inbox",
  "2027-05-10": "swear",
  "2027-05-11": "learn",
  "2027-05-12": "chunk",
  "2027-05-13": "smack",
  "2027-05-14": "drive",
  "2027-05-15": "inert",
  "2027-05-16": "lower",
  "2027-05-17": "gassy",
  "2027-05-18": "fluff",
  "2027-05-19": "poesy",
  "2027-05-20": "dogma",
  "2027-05-21": "vital",
  "2027-05-22": "abase",
  "2027-05-23": "growl",
  "2027-05-24": "prawn",
  "2027-05-25": "icing",
  "2027-05-26": "hoard",
  "2027-05-27": "comic",
  "2027-05-28": "trade",
  "2027-05-29": "chili",
  "2027-05-30": "belch",
  "2027-05-31": "hater",
  "2027-06-01": "frisk",
  "2027-06-02": "drone",
  "2027-06-03": "toast",
  "2027-06-04": "party",
  "2027-06-05": "every",
  "2027-06-06": "overt",
  "2027-06-07": "bleak",
  "2027-06-08": "woven",
  "2027-06-09": "abode",
  "2027-06-10": "blurt",
  "2027-06-11": "cream",
  "2027-06-12": "spare",
  "2027-06-13": "slice",
  "2027-06-14": "clerk",
  "2027-06-15": "pesky",
  "2027-06-16": "trice",
  "2027-06-17": "dwarf",
  "2027-06-18": "screw",
  "2027-06-19": "drill",
  "2027-06-20": "flown",
  "2027-06-21": "human",
  "2027-06-22": "fjord",
  "2027-06-23": "spore",
  "2027-06-24": "milky",
  "2027-06-25": "slime",
  "2027-06-26": "frond",
  "2027-06-27": "tread",
  "2027-06-28": "unlit",
  "2027-06-29": "cynic",
  "2027-06-30": "carat",
  "2027-07-01": "reply",
  "2027-07-02": "epoxy",
  "2027-07-03": "ascot",
  "2027-07-04": "exult",
  "2027-07-05": "stage",
  "2027-07-06": "funny",
  "2027-07-07": "think",
  "2027-07-08": "singe",
  "2027-07-09": "swept",
  "2027-07-10": "cliff",
  "2027-07-11": "cargo",
  "2027-07-12": "react",
  "2027-07-13": "merry",
  "2027-07-14": "dusky",
  "2027-07-15": "shine",
  "2027-07-16": "polar",
  "2027-07-17": "booty",
  "2027-07-18": "stomp",
  "2027-07-19": "plush",
  "2027-07-20": "hippy",
  "2027-07-21": "ninny",
  "2027-07-22": "whose",
  "2027-07-23": "pansy",
  "2027-07-24": "drier",
  "2027-07-25": "knock",
  "2027-07-26": "catty",
  "2027-07-27": "occur",
  "2027-07-28": "burst",
  "2027-07-29": "gloat",
  "2027-07-30": "flunk",
  "2027-07-31": "snore",
  "2027-08-01": "cramp",
  "2027-08-02": "brawl",
  "2027-08-03": "waste",
  "2027-08-04": "gaffe",
  "2027-08-05": "focus",
  "2027-08-06": "scram",
  "2027-08-07": "proud",
  "2027-08-08": "hoist",
  "2027-08-09": "plier",
  "2027-08-10": "quote",
  "2027-08-11": "brawn",
  "2027-08-12": "wight",
  "2027-08-13": "clout",
  "2027-08-14": "acorn",
  "2027-08-15": "found",
  "2027-08-16": "jumbo",
  "2027-08-17": "toddy",
  "2027-08-18": "aptly",
  "2027-08-19": "taboo",
  "2027-08-20": "horde",
  "2027-08-21": "droop",
  "2027-08-22": "guile",
  "2027-08-23": "eject",
  "2027-08-24": "tithe",
  "2027-08-25": "tiara",
  "2027-08-26": "infer",
  "2027-08-27": "juice",
  "2027-08-28": "usual",
  "2027-08-29": "hatch",
  "2027-08-30": "agree",
  "2027-08-31": "primo",
  "2027-09-01": "alpha",
  "2027-09-02": "filth",
  "2027-09-03": "smock",
  "2027-09-04": "needy",
  "2027-09-05": "stint",
  "2027-09-06": "leper",
  "2027-09-07": "wrath",
  "2027-09-08": "witty",
  "2027-09-09": "agony",
  "2027-09-10": "print",
  "2027-09-11": "easel",
  "2027-09-12": "faith",
  "2027-09-13": "bloat",
  "2027-09-14": "remit",
  "2027-09-15": "elect",
  "2027-09-16": "fixer",
  "2027-09-17": "pouty",
  "2027-09-18": "bulky",
  "2027-09-19": "joker",
  "2027-09-20": "vault",
  "2027-09-21": "agora",
  "2027-09-22": "stiff",
  "2027-09-23": "vouch",
  "2027-09-24": "jelly",
  "2027-09-25": "holly",
  "2027-09-26": "loath",
  "2027-09-27": "crimp",
  "2027-09-28": "tight",
  "2027-09-29": "rouge",
  "2027-09-30": "fully",
  "2027-10-01": "decal",
  "2027-10-02": "nomad",
  "2027-10-03": "dowry",
  "2027-10-04": "tawny",
  "2027-10-05": "befit",
  "2027-10-06": "skiff",
  "2027-10-07": "admin",
  "2027-10-08": "squat",
  "2027-10-09": "spine",
  "2027-10-10": "patio",
  "2027-10-11": "vomit",
  "2027-10-12": "sheik",
  "2027-10-13": "obese",
  "2027-10-14": "crest",
  "2027-10-15": "macro",
  "2027-10-16": "gonad",
  "2027-10-17": "rayon",
  "2027-10-18": "grind",
  "2027-10-19": "foggy",
  "2027-10-20": "octet",
  "2027-10-21": "coach",
  "2027-10-22": "crypt",
  "2027-10-23": "adage",
  "2027-10-24": "mural",
  "2027-10-25": "unity",
  "2027-10-26": "borax",
  "2027-10-27": "diver",
  "2027-10-28": "tiger",
  "2027-10-29": "kebab",
  "2027-10-30": "salad",
  "2027-10-31": "lease",
  "2027-11-01": "scout",
  "2027-11-02": "vicar",
  "2027-11-03": "viper",
  "2027-11-04": "finer",
  "2027-11-05": "stork",
  "2027-11-06": "crook",
  "2027-11-07": "smoke",
  "2027-11-08": "mound",
  "2027-11-09": "wimpy",
  "2027-11-10": "regal",
  "2027-11-11": "lefty",
  "2027-11-12": "purge",
  "2027-11-13": "anger",
  "2027-11-14": "green",
  "2027-11-15": "lipid",
  "2027-11-16": "bulge",
  "2027-11-17": "angel",
  "2027-11-18": "breed",
  "2027-11-19": "puree",
  "2027-11-20": "rider",
  "2027-11-21": "loose",
  "2027-11-22": "cleft",
  "2027-11-23": "sieve",
  "2027-11-24": "droll",
  "2027-11-25": "handy",
  "2027-11-26": "actor",
  "2027-11-27": "sword",
  "2027-11-28": "renal",
  "2027-11-29": "totem",
  "2027-11-30": "ionic",
  "2027-12-01": "verve",
  "2027-12-02": "trawl",
  "2027-12-03": "scent",
  "2027-12-04": "serve",
  "2027-12-05": "brook",
  "2027-12-06": "rumor",
  "2027-12-07": "worse",
  "2027-12-08": "chaff",
  "2027-12-09": "fewer",
  "2027-12-10": "spool",
  "2027-12-11": "eagle",
  "2027-12-12": "coven",
  "2027-12-13": "grade",
  "2027-12-14": "erode",
  "2027-12-15": "drake",
  "2027-12-16": "blood",
  "2027-12-17": "heron",
  "2027-12-18": "leery",
  "2027-12-19": "whelp",
  "2027-12-20": "press",
  "2027-12-21": "stone",
  "2027-12-22": "which",
  "2027-12-23": "harsh",
  "2027-12-24": "squad",
  "2027-12-25": "filly",
  "2027-12-26": "skier",
  "2027-12-27": "super",
  "2027-12-28": "shush",
  "2027-12-29": "scorn",
  "2027-12-30": "evade",
  "2027-12-31": "solar",
  "2028-01-01": "ruddy",
  "2028-01-02": "chart",
  "2028-01-03": "soggy",
  "2028-01-04": "caste",
  "2028-01-05": "dilly",
  "2028-01-06": "asset",
  "2028-01-07": "savor",
  "2028-01-08": "bleep",
  "2028-01-09": "thief",
  "2028-01-10": "unite",
  "2028-01-11": "stain",
  "2028-01-12": "adept",
  "2028-01-13": "ether",
  "2028-01-14": "opera",
  "2028-01-15": "dealt",
  "2028-01-16": "spook",
  "2028-01-17": "blade",
  "2028-01-18": "banal",
  "2028-01-19": "straw",
  "2028-01-20": "binge",
  "2028-01-21": "macaw",
  "2028-01-22": "boule",
  "2028-01-23": "annoy",
  "2028-01-24": "spoke",
  "2028-01-25": "guava",
  "2028-01-26": "pixel",
  "2028-01-27": "jewel",
  "2028-01-28": "offal",
  "2028-01-29": "abled",
  "2028-01-30": "penne",
  "2028-01-31": "purer",
  "2028-02-01": "gross",
  "2028-02-02": "knoll",
  "2028-02-03": "saner",
  "2028-02-04": "grail",
  "2028-02-05": "petal",
  "2028-02-06": "beast",
  "2028-02-07": "medic",
  "2028-02-08": "sully",
  "2028-02-09": "table",
  "2028-02-10": "merit",
  "2028-02-11": "tardy",
  "2028-02-12": "pizza",
  "2028-02-13": "heath",
  "2028-02-14": "thick",
  "2028-02-15": "blurb",
  "2028-02-16": "slide",
  "2028-02-17": "spasm",
  "2028-02-18": "verge",
  "2028-02-19": "recap",
  "2028-02-20": "light",
  "2028-02-21": "fence",
  "2028-02-22": "vigor",
  "2028-02-23": "chalk",
  "2028-02-24": "spilt",
  "2028-02-25": "cinch",
  "2028-02-26": "ingot",
  "2028-02-27": "piety",
  "2028-02-28": "junta",
  "2028-02-29": "idyll",
  "2028-03-01": "while",
  "2028-03-02": "spank",
  "2028-03-03": "thigh",
  "2028-03-04": "expel",
  "2028-03-05": "forge",
  "2028-03-06": "surly",
  "2028-03-07": "cache",
  "2028-03-08": "hazel",
  "2028-03-09": "cause",
  "2028-03-10": "swash",
  "2028-03-11": "climb",
  "2028-03-12": "cigar",
  "2028-03-13": "smile",
  "2028-03-14": "worth",
  "2028-03-15": "candy",
  "2028-03-16": "poser",
  "2028-03-17": "nicer",
  "2028-03-18": "agile",
  "2028-03-19": "gripe",
  "2028-03-20": "shame",
  "2028-03-21": "ratty",
  "2028-03-22": "junto",
  "2028-03-23": "flair",
  "2028-03-24": "cloth",
  "2028-03-25": "minty",
  "2028-03-26": "chard",
  "2028-03-27": "smite",
  "2028-03-28": "annul",
  "2028-03-29": "owing",
  "2028-03-30": "house",
  "2028-03-31": "debug",
  "2028-04-01": "stick",
  "2028-04-02": "belly",
  "2028-04-03": "frock",
  "2028-04-04": "riper",
  "2028-04-05": "stunk",
  "2028-04-06": "swift",
  "2028-04-07": "shelf",
  "2028-04-08": "hedge",
  "2028-04-09": "serif",
  "2028-04-10": "draft",
  "2028-04-11": "glide",
  "2028-04-12": "unfed",
  "2028-04-13": "merge",
  "2028-04-14": "rabbi",
  "2028-04-15": "aider",
  "2028-04-16": "notch",
  "2028-04-17": "renew",
  "2028-04-18": "bobby",
  "2028-04-19": "mange",
  "2028-04-20": "churn",
  "2028-04-21": "robot",
  "2028-04-22": "grout",
  "2028-04-23": "quilt",
  "2028-04-24": "willy",
  "2028-04-25": "swoon",
  "2028-04-26": "swirl",
  "2028-04-27": "envoy",
  "2028-04-28": "scald",
  "2028-04-29": "stave",
  "2028-04-30": "blimp",
  "2028-05-01": "elope",
  "2028-05-02": "valor",
  "2028-05-03": "midst",
  "2028-05-04": "staff",
  "2028-05-05": "grown",
  "2028-05-06": "fussy",
  "2028-05-07": "plain",
  "2028-05-08": "trait",
  "2028-05-09": "dowdy",
  "2028-05-10": "grape",
  "2028-05-11": "ledge",
  "2028-05-12": "mover",
  "2028-05-13": "rogue",
  "2028-05-14": "brake",
  "2028-05-15": "fanny",
  "2028-05-16": "chide",
  "2028-05-17": "venue",
  "2028-05-18": "ferry",
  "2028-05-19": "skunk",
  "2028-05-20": "bride",
  "2028-05-21": "leapt",
  "2028-05-22": "lapse",
  "2028-05-23": "mogul",
  "2028-05-24": "noose",
  "2028-05-25": "range",
  "2028-05-26": "widow",
  "2028-05-27": "turbo",
  "2028-05-28": "flask",
  "2028-05-29": "couch",
  "2028-05-30": "never",
  "2028-05-31": "arson",
  "2028-06-01": "cress",
  "2028-06-02": "basil",
  "2028-06-03": "dumpy",
  "2028-06-04": "tutor",
  "2028-06-05": "gypsy",
  "2028-06-06": "artsy",
  "2028-06-07": "grill",
  "2028-06-08": "ninth",
  "2028-06-09": "omega",
  "2028-06-10": "taste",
  "2028-06-11": "width",
  "2028-06-12": "azure",
  "2028-06-13": "pulpy",
  "2028-06-14": "filmy",
  "2028-06-15": "rivet",
  "2028-06-16": "lynch",
  "2028-06-17": "seven",
  "2028-06-18": "crass",
  "2028-06-19": "jaunt",
  "2028-06-20": "onset",
  "2028-06-21": "louse",
  "2028-06-22": "scamp",
  "2028-06-23": "wreak",
  "2028-06-24": "lobby",
  "2028-06-25": "tipsy",
  "2028-06-26": "scuba",
  "2028-06-27": "voice",
  "2028-06-28": "voila",
  "2028-06-29": "chess",
  "2028-06-30": "again",
  "2028-07-01": "itchy",
  "2028-07-02": "beech",
  "2028-07-03": "acrid",
  "2028-07-04": "friar",
  "2028-07-05": "khaki",
  "2028-07-06": "wheat",
  "2028-07-07": "murky",
  "2028-07-08": "there",
  "2028-07-09": "debut",
  "2028-07-10": "sorry",
  "2028-07-11": "rural",
  "2028-07-12": "sheen",
  "2028-07-13": "whiff",
  "2028-07-14": "cower",
  "2028-07-15": "lilac",
  "2028-07-16": "later",
  "2028-07-17": "swami",
  "2028-07-18": "truly",
  "2028-07-19": "foray",
  "2028-07-20": "affix",
  "2028-07-21": "threw",
  "2028-07-22": "idiot",
  "2028-07-23": "cadet",
  "2028-07-24": "plane",
  "2028-07-25": "poise",
  "2028-07-26": "tilde",
  "2028-07-27": "fling",
  "2028-07-28": "moose",
  "2028-07-29": "bowel",
  "2028-07-30": "dross",
  "2028-07-31": "level",
  "2028-08-01": "eater",
  "2028-08-02": "dopey",
  "2028-08-03": "align",
  "2028-08-04": "raspy",
  "2028-08-05": "leash",
  "2028-08-06": "forth",
  "2028-08-07": "crust",
  "2028-08-08": "bring",
  "2028-08-09": "shove",
  "2028-08-10": "motor",
  "2028-08-11": "craft",
  "2028-08-12": "maybe",
  "2028-08-13": "augur",
  "2028-08-14": "slung",
  "2028-08-15": "begin",
  "2028-08-16": "virus",
  "2028-08-17": "array",
  "2028-08-18": "unwed",
  "2028-08-19": "juror",
  "2028-08-20": "tried",
  "2028-08-21": "stash",
  "2028-08-22": "tryst",
  "2028-08-23": "plaza",
  "2028-08-24": "nerve",
  "2028-08-25": "shirk",
  "2028-08-26": "exist",
  "2028-08-27": "usher",
  "2028-08-28": "youth",
  "2028-08-29": "staid",
  "2028-08-30": "farce",
  "2028-08-31": "speed",
  "2028-09-01": "lupus",
  "2028-09-02": "budge",
  "2028-09-03": "exile",
  "2028-09-04": "gland",
  "2028-09-05": "twine",
  "2028-09-06": "error",
  "2028-09-07": "poppy",
  "2028-09-08": "using",
  "2028-09-09": "tarot",
  "2028-09-10": "joust",
  "2028-09-11": "suite",
  "2028-09-12": "plied",
  "2028-09-13": "fault",
  "2028-09-14": "stark",
  "2028-09-15": "donut",
  "2028-09-16": "stood",
  "2028-09-17": "exact",
  "2028-09-18": "scarf",
  "2028-09-19": "ovate",
  "2028-09-20": "wheel",
  "2028-09-21": "diner",
  "2028-09-22": "brisk",
  "2028-09-23": "cello",
  "2028-09-24": "sower",
  "2028-09-25": "plumb",
  "2028-09-26": "allay",
  "2028-09-27": "prank",
  "2028-09-28": "welch",
  "2028-09-29": "arbor",
  "2028-09-30": "pride",
  "2028-10-01": "equal",
  "2028-10-02": "gorge",
  "2028-10-03": "bison",
  "2028-10-04": "tamer",
  "2028-10-05": "story",
  "2028-10-06": "pupil",
  "2028-10-07": "felon",
  "2028-10-08": "shear",
  "2028-10-09": "gazer",
  "2028-10-10": "loopy",
  "2028-10-11": "ombre",
  "2028-10-12": "igloo",
  "2028-10-13": "pilot",
  "2028-10-14": "paler",
  "2028-10-15": "rigor",
  "2028-10-16": "flash",
  "2028-10-17": "marry",
  "2028-10-18": "sleet",
  "2028-10-19": "great",
  "2028-10-20": "abbey",
  "2028-10-21": "panic",
  "2028-10-22": "rupee",
  "2028-10-23": "puffy",
  "2028-10-24": "salvo",
  "2028-10-25": "lorry",
  "2028-10-26": "score",
  "2028-10-27": "rower",
  "2028-10-28": "umbra",
  "2028-10-29": "chill",
  "2028-10-30": "parka",
  "2028-10-31": "alibi",
  "2028-11-01": "whole",
  "2028-11-02": "shuck",
  "2028-11-03": "graft",
  "2028-11-04": "ditch",
  "2028-11-05": "baste",
  "2028-11-06": "broil",
  "2028-11-07": "undue",
  "2028-11-08": "hyena",
  "2028-11-09": "carry",
  "2028-11-10": "slyly",
  "2028-11-11": "rowdy",
  "2028-11-12": "mambo",
  "2028-11-13": "scary",
  "2028-11-14": "blitz",
  "2028-11-15": "boxer",
  "2028-11-16": "civic",
  "2028-11-17": "whack",
  "2028-11-18": "bloom",
  "2028-11-19": "media",
  "2028-11-20": "sling",
  "2028-11-21": "femme",
  "2028-11-22": "gravy",
  "2028-11-23": "mower",
  "2028-11-24": "ovary",
  "2028-11-25": "bacon",
  "2028-11-26": "sooth",
  "2028-11-27": "manor",
  "2028-11-28": "mocha",
  "2028-11-29": "visit",
  "2028-11-30": "abbot",
  "2028-12-01": "study",
  "2028-12-02": "shade",
  "2028-12-03": "fleck",
  "2028-12-04": "flood",
  "2028-12-05": "havoc",
  "2028-12-06": "glove",
  "2028-12-07": "cubic",
  "2028-12-08": "paddy",
  "2028-12-09": "ennui",
  "2028-12-10": "gleam",
  "2028-12-11": "older",
  "2028-12-12": "quirk",
  "2028-12-13": "crone",
  "2028-12-14": "build",
  "2028-12-15": "radar",
  "2028-12-16": "fudge",
  "2028-12-17": "pudgy",
  "2028-12-18": "drank",
  "2028-12-19": "place",
  "2028-12-20": "latch",
  "2028-12-21": "freed",
  "2028-12-22": "agent",
  "2028-12-23": "tacky",
  "2028-12-24": "roach",
  "2028-12-25": "stool",
  "2028-12-26": "blank",
  "2028-12-27": "plead",
  "2028-12-28": "dance",
  "2028-12-29": "stake",
  "2028-12-30": "stamp",
  "2028-12-31": "noisy",
  "2029-01-01": "sepia",
  "2029-01-02": "awoke",
  "2029-01-03": "halve",
  "2029-01-04": "anvil",
  "2029-01-05": "agape",
  "2029-01-06": "carve",
  "2029-01-07": "colon",
  "2029-01-08": "skimp",
  "2029-01-09": "crier",
  "2029-01-10": "revue",
  "2029-01-11": "toxin",
  "2029-01-12": "gooey",
  "2029-01-13": "roast",
  "2029-01-14": "young",
  "2029-01-15": "lunch",
  "2029-01-16": "rover",
  "2029-01-17": "waltz",
  "2029-01-18": "drunk",
  "2029-01-19": "nasal",
  "2029-01-20": "sewer",
  "2029-01-21": "troll",
  "2029-01-22": "twice",
  "2029-01-23": "delay",
  "2029-01-24": "watch",
  "2029-01-25": "aside",
  "2029-01-26": "crime",
  "2029-01-27": "snake",
  "2029-01-28": "joist",
  "2029-01-29": "floor",
  "2029-01-30": "goner",
  "2029-01-31": "amaze",
  "2029-02-01": "mucky",
  "2029-02-02": "flail",
  "2029-02-03": "preen",
  "2029-02-04": "pushy",
  "2029-02-05": "novel",
  "2029-02-06": "alley",
  "2029-02-07": "cable",
  "2029-02-08": "those",
  "2029-02-09": "caper",
  "2029-02-10": "onion",
  "2029-02-11": "slain",
  "2029-02-12": "clock",
  "2029-02-13": "fetal",
  "2029-02-14": "conic",
  "2029-02-15": "shard",
  "2029-02-16": "ridge",
  "2029-02-17": "folly",
  "2029-02-18": "avian",
  "2029-02-19": "equip",
  "2029-02-20": "sixty",
  "2029-02-21": "pagan",
  "2029-02-22": "shone",
  "2029-02-23": "faint",
  "2029-02-24": "myrrh",
  "2029-02-25": "adapt",
  "2029-02-26": "harem",
  "2029-02-27": "cater",
  "2029-02-28": "liege",
  "2029-03-01": "enjoy",
  "2029-03-02": "angst",
  "2029-03-03": "deign",
  "2029-03-04": "tower",
  "2029-03-05": "vegan",
  "2029-03-06": "prize",
  "2029-03-07": "lusty",
  "2029-03-08": "lathe",
  "2029-03-09": "pedal",
  "2029-03-10": "prowl",
  "2029-03-11": "piney",
  "2029-03-12": "saucy",
  "2029-03-13": "canon",
  "2029-03-14": "wordy",
  "2029-03-15": "swoop",
  "2029-03-16": "irate",
  "2029-03-17": "empty",
  "2029-03-18": "fifth",
  "2029-03-19": "putty",
  "2029-03-20": "billy",
  "2029-03-21": "truth",
  "2029-03-22": "theme",
  "2029-03-23": "topic",
  "2029-03-24": "local",
  "2029-03-25": "tibia",
  "2029-03-26": "drove",
  "2029-03-27": "haunt",
  "2029-03-28": "nutty",
  "2029-03-29": "throb",
  "2029-03-30": "stair",
  "2029-03-31": "hussy",
  "2029-04-01": "vying",
  "2029-04-02": "bliss",
  "2029-04-03": "imbue",
  "2029-04-04": "cacti",
  "2029-04-05": "swine",
  "2029-04-06": "aware",
  "2029-04-07": "cloud",
  "2029-04-08": "spire",
  "2029-04-09": "porch",
  "2029-04-10": "winch",
  "2029-04-11": "wacky",
  "2029-04-12": "belle",
  "2029-04-13": "steal",
  "2029-04-14": "tepee",
  "2029-04-15": "devil",
  "2029-04-16": "chick",
  "2029-04-17": "slave",
  "2029-04-18": "sheer",
  "2029-04-19": "briny",
  "2029-04-20": "tangy",
  "2029-04-21": "fauna",
  "2029-04-22": "natal",
  "2029-04-23": "sigma",
  "2029-04-24": "lofty",
  "2029-04-25": "right",
  "2029-04-26": "strip",
  "2029-04-27": "judge",
  "2029-04-28": "maple",
  "2029-04-29": "plume",
  "2029-04-30": "short",
  "2029-05-01": "tooth",
  "2029-05-02": "sting",
  "2029-05-03": "touch",
  "2029-05-04": "creme",
  "2029-05-05": "axion",
  "2029-05-06": "cairn",
  "2029-05-07": "wedge",
  "2029-05-08": "essay",
  "2029-05-09": "valid",
  "2029-05-10": "meter",
  "2029-05-11": "close",
  "2029-05-12": "quill",
  "2029-05-13": "olden",
  "2029-05-14": "sinew",
  "2029-05-15": "picky",
  "2029-05-16": "mince",
  "2029-05-17": "white",
  "2029-05-18": "apnea",
  "2029-05-19": "shank",
  "2029-05-20": "shrug",
  "2029-05-21": "guild",
  "2029-05-22": "vogue",
  "2029-05-23": "adobe",
  "2029-05-24": "feral",
  "2029-05-25": "donor",
  "2029-05-26": "trove",
  "2029-05-27": "afoul",
  "2029-05-28": "quack",
  "2029-05-29": "drift",
  "2029-05-30": "crave",
  "2029-05-31": "penal",
  "2029-06-01": "usage",
  "2029-06-02": "terse",
  "2029-06-03": "windy",
  "2029-06-04": "erect",
  "2029-06-05": "favor",
  "2029-06-06": "count",
  "2029-06-07": "sever",
  "2029-06-08": "curve",
  "2029-06-09": "lasso",
  "2029-06-10": "brand",
  "2029-06-11": "bitty",
  "2029-06-12": "goofy",
  "2029-06-13": "crank",
  "2029-06-14": "voter",
  "2029-06-15": "satyr",
  "2029-06-16": "slunk",
  "2029-06-17": "queer",
  "2029-06-18": "ounce",
  "2029-06-19": "humph",
  "2029-06-20": "sweat",
  "2029-06-21": "court",
  "2029-06-22": "wench",
  "2029-06-23": "bylaw",
  "2029-06-24": "steak",
  "2029-06-25": "stole",
  "2029-06-26": "niche",
  "2029-06-27": "clear",
  "2029-06-28": "covet",
  "2029-06-29": "chime",
  "2029-06-30": "third",
  "2029-07-01": "nobly",
  "2029-07-02": "weigh",
  "2029-07-03": "payer",
  "2029-07-04": "chump",
  "2029-07-05": "alloy",
  "2029-07-06": "datum",
  "2029-07-07": "koala",
  "2029-07-08": "mushy",
  "2029-07-09": "movie",
  "2029-07-10": "ensue",
  "2029-07-11": "smith",
  "2029-07-12": "newer",
  "2029-07-13": "layer",
  "2029-07-14": "issue",
  "2029-07-15": "kitty",
  "2029-07-16": "broad",
  "2029-07-17": "crept",
  "2029-07-18": "baler",
  "2029-07-19": "mangy",
  "2029-07-20": "shrub",
  "2029-07-21": "salve",
  "2029-07-22": "horse",
  "2029-07-23": "opium",
  "2029-07-24": "girly",
  "2029-07-25": "match",
  "2029-07-26": "taunt",
  "2029-07-27": "deuce",
  "2029-07-28": "bunny",
  "2029-07-29": "black",
  "2029-07-30": "stump",
  "2029-07-31": "cacao",
  "2029-08-01": "plaid",
  "2029-08-02": "untie",
  "2029-08-03": "apron",
  "2029-08-04": "stoke",
  "2029-08-05": "hurry",
  "2029-08-06": "amply",
  "2029-08-07": "cumin",
  "2029-08-08": "polyp",
  "2029-08-09": "sober",
  "2029-08-10": "bosom",
  "2029-08-11": "treat",
  "2029-08-12": "axiom",
  "2029-08-13": "defer",
  "2029-08-14": "lumpy",
  "2029-08-15": "fiery",
  "2029-08-16": "sandy",
  "2029-08-17": "otter",
  "2029-08-18": "droit",
  "2029-08-19": "finch",
  "2029-08-20": "ebony",
  "2029-08-21": "spoof",
  "2029-08-22": "adore",
  "2029-08-23": "ashen",
  "2029-08-24": "spear",
  "2029-08-25": "epoch",
  "2029-08-26": "sleep",
  "2029-08-27": "rainy",
  "2029-08-28": "decoy",
  "2029-08-29": "poker",
  "2029-08-30": "dally",
  "2029-08-31": "dwelt",
  "2029-09-01": "genie",
  "2029-09-02": "sooty",
  "2029-09-03": "bribe",
  "2029-09-04": "debit",
  "2029-09-05": "caulk",
  "2029-09-06": "trump",
  "2029-09-07": "champ",
  "2029-09-08": "slack",
  "2029-09-09": "nadir",
  "2029-09-10": "trick",
  "2029-09-11": "seedy",
  "2029-09-12": "crick",
  "2029-09-13": "retro",
  "2029-09-14": "melon",
  "2029-09-15": "geese",
  "2029-09-16": "parer",
  "2029-09-17": "dicey",
  "2029-09-18": "giddy",
  "2029-09-19": "polka",
  "2029-09-20": "gummy",
  "2029-09-21": "metro",
  "2029-09-22": "shift",
  "2029-09-23": "stare",
  "2029-09-24": "kneed",
  "2029-09-25": "sixth",
  "2029-09-26": "patsy",
  "2029-09-27": "bough",
  "2029-09-28": "surge",
  "2029-09-29": "smirk",
  "2029-09-30": "wager",
  "2029-10-01": "baton",
  "2029-10-02": "papal",
  "2029-10-03": "refit",
  "2029-10-04": "snuff",
  "2029-10-05": "adopt",
  "2029-10-06": "ester",
  "2029-10-07": "croup",
  "2029-10-08": "fresh",
  "2029-10-09": "spelt",
  "2029-10-10": "bonus",
  "2029-10-11": "fetus",
  "2029-10-12": "reach",
  "2029-10-13": "fecal",
  "2029-10-14": "prude",
  "2029-10-15": "libel",
  "2029-10-16": "paint",
  "2029-10-17": "evoke",
  "2029-10-18": "missy",
  "2029-10-19": "stock",
  "2029-10-20": "spout",
  "2029-10-21": "boast",
  "2029-10-22": "minor",
  "2029-10-23": "glaze",
  "2029-10-24": "stand",
  "2029-10-25": "solid",
  "2029-10-26": "queue",
  "2029-10-27": "stank",
  "2029-10-28": "flush",
  "2029-10-29": "panel",
  "2029-10-30": "wince",
  "2029-10-31": "child",
  "2029-11-01": "lyric",
  "2029-11-02": "snail",
  "2029-11-03": "dizzy",
  "2029-11-04": "froth",
  "2029-11-05": "ovine",
  "2029-11-06": "guest",
  "2029-11-07": "swamp",
  "2029-11-08": "dodge",
  "2029-11-09": "clove",
  "2029-11-10": "depth",
  "2029-11-11": "sweet",
  "2029-11-12": "perch",
  "2029-11-13": "ivory",
  "2029-11-14": "twang",
  "2029-11-15": "sneer",
  "2029-11-16": "guppy",
  "2029-11-17": "radii",
  "2029-11-18": "groin",
  "2029-11-19": "drape",
  "2029-11-20": "crepe",
  "2029-11-21": "limbo",
  "2029-11-22": "druid",
  "2029-11-23": "dingo",
  "2029-11-24": "evict",
  "2029-11-25": "shirt",
  "2029-11-26": "rouse",
  "2029-11-27": "liver",
  "2029-11-28": "raise",
  "2029-11-29": "algae",
  "2029-11-30": "burly",
  "2029-12-01": "audit",
  "2029-12-02": "prior",
  "2029-12-03": "hobby",
  "2029-12-04": "cling",
  "2029-12-05": "etude",
  "2029-12-06": "tacit",
  "2029-12-07": "pearl",
  "2029-12-08": "greed",
  "2029-12-09": "creed",
  "2029-12-10": "arena",
  "2029-12-11": "slurp",
  "2029-12-12": "buyer",
  "2029-12-13": "edify",
  "2029-12-14": "raven",
  "2029-12-15": "snort",
  "2029-12-16": "scene",
  "2029-12-17": "crazy",
  "2029-12-18": "pithy",
  "2029-12-19": "assay",
  "2029-12-20": "peach",
  "2029-12-21": "flick",
  "2029-12-22": "mayor",
  "2029-12-23": "niece",
  "2029-12-24": "jumpy",
  "2029-12-25": "pubic",
  "2029-12-26": "sight",
  "2029-12-27": "quest",
  "2029-12-28": "digit",
  "2029-12-29": "class",
  "2029-12-30": "clang",
  "2029-12-31": "rusty",
  "2030-01-01": "stilt",
  "2030-01-02": "lymph",
  "2030-01-03": "leaky",
  "2030-01-04": "mason",
  "2030-01-05": "craze",
  "2030-01-06": "sulky",
  "2030-01-07": "plate",
  "2030-01-08": "beady",
  "2030-01-09": "psalm",
  "2030-01-10": "began",
  "2030-01-11": "final",
  "2030-01-12": "spawn",
  "2030-01-13": "fatty",
  "2030-01-14": "chuck",
  "2030-01-15": "lying",
  "2030-01-16": "inept",
  "2030-01-17": "fetid",
  "2030-01-18": "quash",
  "2030-01-19": "curly",
  "2030-01-20": "idiom",
  "2030-01-21": "storm",
  "2030-01-22": "shake",
  "2030-01-23": "dusty",
  "2030-01-24": "lucid",
  "2030-01-25": "ghoul",
  "2030-01-26": "ruler",
  "2030-01-27": "facet",
  "2030-01-28": "fungi",
  "2030-01-29": "mirth",
  "2030-01-30": "zesty",
  "2030-01-31": "check",
  "2030-02-01": "salsa",
  "2030-02-02": "flout",
  "2030-02-03": "unfit",
  "2030-02-04": "duvet",
  "2030-02-05": "wring",
  "2030-02-06": "prone",
  "2030-02-07": "elite",
  "2030-02-08": "royal",
  "2030-02-09": "tepid",
  "2030-02-10": "revel",
  "2030-02-11": "cheap",
  "2030-02-12": "canoe",
  "2030-02-13": "flour",
  "2030-02-14": "buggy",
  "2030-02-15": "prism",
  "2030-02-16": "entry",
  "2030-02-17": "fibre",
  "2030-02-18": "spark",
  "2030-02-19": "slosh",
  "2030-02-20": "gourd",
  "2030-02-21": "visor",
  "2030-02-22": "bunch",
  "2030-02-23": "slink",
  "2030-02-24": "nanny",
  "2030-02-25": "blunt",
  "2030-02-26": "uncle",
  "2030-02-27": "punch",
  "2030-02-28": "oaken",
  "2030-03-01": "edict",
  "2030-03-02": "abide",
  "2030-03-03": "gully",
  "2030-03-04": "major",
  "2030-03-05": "ethic",
  "2030-03-06": "shorn",
  "2030-03-07": "verse",
  "2030-03-08": "downy",
  "2030-03-09": "rocky",
  "2030-03-10": "extra",
  "2030-03-11": "racer",
  "2030-03-12": "peril",
  "2030-03-13": "blend",
  "2030-03-14": "pesto",
  "2030-03-15": "livid",
  "2030-03-16": "frost",
  "2030-03-17": "clank",
  "2030-03-18": "parry",
  "2030-03-19": "brief",
  "2030-03-20": "basic",
  "2030-03-21": "pluck",
  "2030-03-22": "crane",
  "2030-03-23": "baker",
  "2030-03-24": "pleat",
  "2030-03-25": "gecko",
  "2030-03-26": "brown",
  "2030-03-27": "diode",
  "2030-03-28": "acute",
  "2030-03-29": "riser",
  "2030-03-30": "imply",
  "2030-03-31": "husky",
  "2030-04-01": "shook",
  "2030-04-02": "fiber",
  "2030-04-03": "dowel",
  "2030-04-04": "drool",
  "2030-04-05": "elude",
  "2030-04-06": "wound",
  "2030-04-07": "wispy",
  "2030-04-08": "legal",
  "2030-04-09": "pecan",
  "2030-04-10": "gavel",
  "2030-04-11": "loser",
  "2030-04-12": "shiny",
  "2030-04-13": "known",
  "2030-04-14": "ditty",
  "2030-04-15": "crash",
  "2030-04-16": "gumbo",
  "2030-04-17": "laden",
  "2030-04-18": "hyper",
  "2030-04-19": "cluck",
  "2030-04-20": "flack",
  "2030-04-21": "grain",
  "2030-04-22": "fella",
  "2030-04-23": "crump",
  "2030-04-24": "crawl",
  "2030-04-25": "query",
  "2030-04-26": "speak",
  "2030-04-27": "olive",
  "2030-04-28": "navel",
  "2030-04-29": "allot",
  "2030-04-30": "clash",
  "2030-05-01": "giant",
  "2030-05-02": "decay",
  "2030-05-03": "flung",
  "2030-05-04": "rearm",
  "2030-05-05": "hotly",
  "2030-05-06": "comet",
  "2030-05-07": "other",
  "2030-05-08": "gawky",
  "2030-05-09": "taint",
  "2030-05-10": "front",
  "2030-05-11": "dolly",
  "2030-05-12": "rival",
  "2030-05-13": "gnash",
  "2030-05-14": "shark",
  "2030-05-15": "stalk",
  "2030-05-16": "vaunt",
  "2030-05-17": "salon",
  "2030-05-18": "jiffy",
  "2030-05-19": "limit",
  "2030-05-20": "least",
  "2030-05-21": "choke",
  "2030-05-22": "aglow",
  "2030-05-23": "start",
  "2030-05-24": "fizzy",
  "2030-05-25": "furry",
  "2030-05-26": "naval",
  "2030-05-27": "bland",
  "2030-05-28": "relic",
  "2030-05-29": "index",
  "2030-05-30": "funky",
  "2030-05-31": "manic",
  "2030-06-01": "login",
  "2030-06-02": "avert",
  "2030-06-03": "juicy",
  "2030-06-04": "sassy",
  "2030-06-05": "detox",
  "2030-06-06": "birth",
  "2030-06-07": "chest",
  "2030-06-08": "rarer",
  "2030-06-09": "ghost",
  "2030-06-10": "cabal",
  "2030-06-11": "wafer",
  "2030-06-12": "wrest",
  "2030-06-13": "utile",
  "2030-06-14": "modem",
  "2030-06-15": "flora",
  "2030-06-16": "ample",
  "2030-06-17": "stray",
  "2030-06-18": "spurn",
  "2030-06-19": "midge",
  "2030-06-20": "thing",
  "2030-06-21": "spade",
  "2030-06-22": "unmet",
  "2030-06-23": "wagon",
  "2030-06-24": "boney",
  "2030-06-25": "fluke",
  "2030-06-26": "fairy",
  "2030-06-27": "beret",
  "2030-06-28": "upper",
  "2030-06-29": "lunge",
  "2030-06-30": "slope",
  "2030-07-01": "haste",
  "2030-07-02": "gloss",
  "2030-07-03": "petty",
  "2030-07-04": "wooer",
  "2030-07-05": "repel",
  "2030-07-06": "leave",
  "2030-07-07": "deity",
  "2030-07-08": "croak",
  "2030-07-09": "posit",
  "2030-07-10": "sharp",
  "2030-07-11": "sadly",
  "2030-07-12": "spike",
  "2030-07-13": "shaky",
  "2030-07-14": "bloke",
  "2030-07-15": "ultra",
  "2030-07-16": "dirge",
  "2030-07-17": "chant",
  "2030-07-18": "along",
  "2030-07-19": "woman",
  "2030-07-20": "hovel",
  "2030-07-21": "thrum",
  "2030-07-22": "feign",
  "2030-07-23": "posse",
  "2030-07-24": "alert",
  "2030-07-25": "snoop",
  "2030-07-26": "snuck",
  "2030-07-27": "dense",
  "2030-07-28": "filet",
  "2030-07-29": "ficus",
  "2030-07-30": "nasty",
  "2030-07-31": "slant",
  "2030-08-01": "topaz",
  "2030-08-02": "shyly",
  "2030-08-03": "dryly",
  "2030-08-04": "shown",
  "2030-08-05": "pinch",
  "2030-08-06": "gamut",
  "2030-08-07": "relay",
  "2030-08-08": "quake",
  "2030-08-09": "canny",
  "2030-08-10": "bawdy",
  "2030-08-11": "focal",
  "2030-08-12": "scoop",
  "2030-08-13": "savoy",
  "2030-08-14": "boost",
  "2030-08-15": "where",
  "2030-08-16": "karma",
  "2030-08-17": "crowd",
  "2030-08-18": "gipsy",
  "2030-08-19": "skill",
  "2030-08-20": "bayou",
  "2030-08-21": "decor",
  "2030-08-22": "plait",
  "2030-08-23": "smash",
  "2030-08-24": "truce",
  "2030-08-25": "honor",
  "2030-08-26": "charm",
  "2030-08-27": "awful",
  "2030-08-28": "shale",
  "2030-08-29": "begun",
  "2030-08-30": "privy",
  "2030-08-31": "tango",
  "2030-09-01": "weird",
  "2030-09-02": "tense",
  "2030-09-03": "guide",
  "2030-09-04": "block",
  "2030-09-05": "fiend",
  "2030-09-06": "aloud",
  "2030-09-07": "throw",
  "2030-09-08": "inane",
  "2030-09-09": "torch",
  "2030-09-10": "blond",
  "2030-09-11": "lingo",
  "2030-09-12": "guise",
  "2030-09-13": "foist",
  "2030-09-14": "blast",
  "2030-09-15": "sport",
  "2030-09-16": "aorta",
  "2030-09-17": "cleat",
  "2030-09-18": "rebel",
  "2030-09-19": "alarm",
  "2030-09-20": "pause",
  "2030-09-21": "clump",
  "2030-09-22": "heart",
  "2030-09-23": "eight",
  "2030-09-24": "bound",
  "2030-09-25": "trust",
  "2030-09-26": "egret",
  "2030-09-27": "pixie",
  "2030-09-28": "inner",
  "2030-09-29": "sissy",
  "2030-09-30": "brush",
  "2030-10-01": "enact",
  "2030-10-02": "askew",
  "2030-10-03": "lurch",
  "2030-10-04": "clued",
  "2030-10-05": "could",
  "2030-10-06": "flank",
  "2030-10-07": "larva",
  "2030-10-08": "derby",
  "2030-10-09": "inlay",
  "2030-10-10": "gamer",
  "2030-10-11": "march",
  "2030-10-12": "basal",
  "2030-10-13": "naive",
  "2030-10-14": "clamp",
  "2030-10-15": "tramp",
  "2030-10-16": "pooch",
  "2030-10-17": "truer",
  "2030-10-18": "weave",
  "2030-10-19": "grave",
  "2030-10-20": "hitch",
  "2030-10-21": "haute",
  "2030-10-22": "teeth",
  "2030-10-23": "thorn",
  "2030-10-24": "floss",
  "2030-10-25": "force",
  "2030-10-26": "iliac",
  "2030-10-27": "goody",
  "2030-10-28": "scale",
  "2030-10-29": "antic",
  "2030-10-30": "minus",
  "2030-10-31": "beset",
  "2030-11-01": "refer",
  "2030-11-02": "camel",
  "2030-11-03": "quail",
  "2030-11-04": "bully",
  "2030-11-05": "color",
  "2030-11-06": "berry",
  "2030-11-07": "slush",
  "2030-11-08": "bluer",
  "2030-11-09": "realm",
  "2030-11-10": "manly",
  "2030-11-11": "linen",
  "2030-11-12": "tunic",
  "2030-11-13": "hinge",
  "2030-11-14": "syrup",
  "2030-11-15": "blame",
  "2030-11-16": "gloom",
  "2030-11-17": "intro",
  "2030-11-18": "tonga",
  "2030-11-19": "sloop",
  "2030-11-20": "smell",
  "2030-11-21": "ripen",
  "2030-11-22": "lanky",
  "2030-11-23": "pound",
  "2030-11-24": "eaten",
  "2030-11-25": "lowly",
  "2030-11-26": "eking",
  "2030-11-27": "fried",
  "2030-11-28": "thump",
  "2030-11-29": "cider",
  "2030-11-30": "speck",
  "2030-12-01": "timid",
  "2030-12-02": "urban",
  "2030-12-03": "brine",
  "2030-12-04": "abhor",
  "2030-12-05": "tweet",
  "2030-12-06": "dodgy",
  "2030-12-07": "furor",
  "2030-12-08": "glory",
  "2030-12-09": "order",
  "2030-12-10": "pulse",
  "2030-12-11": "mercy",
  "2030-12-12": "sloth",
  "2030-12-13": "fetch",
  "2030-12-14": "drink",
  "2030-12-15": "armor",
  "2030-12-16": "anime",
  "2030-12-17": "showy",
  "2030-12-18": "roost",
  "2030-12-19": "share",
  "2030-12-20": "matey",
  "2030-12-21": "randy",
  "2030-12-22": "elegy",
  "2030-12-23": "woozy",
  "2030-12-24": "shire",
  "2030-12-25": "amity",
  "2030-12-26": "cease",
  "2030-12-27": "grace",
  "2030-12-28": "palsy",
  "2030-12-29": "strap",
  "2030-12-30": "stuff",
  "2030-12-31": "locus",
  "2031-01-01": "coral",
  "2031-01-02": "spunk",
  "2031-01-03": "disco",
  "2031-01-04": "built",
  "2031-01-05": "vowel",
  "2031-01-06": "crate",
  "2031-01-07": "piano",
  "2031-01-08": "mauve",
  "2031-01-09": "shaft",
  "2031-01-10": "caddy",
  "2031-01-11": "pouch",
  "2031-01-12": "daunt",
  "2031-01-13": "flyer",
  "2031-01-14": "glint",
  "2031-01-15": "boozy",
  "2031-01-16": "wrack",
  "2031-01-17": "water",
  "2031-01-18": "gusto",
  "2031-01-19": "habit",
  "2031-01-20": "decry",
  "2031-01-21": "yeast",
  "2031-01-22": "rabid",
  "2031-01-23": "synod",
  "2031-01-24": "dunce",
  "2031-01-25": "smote",
  "2031-01-26": "saute",
  "2031-01-27": "scrub",
  "2031-01-28": "mourn",
  "2031-01-29": "audio",
  "2031-01-30": "blown",
  "2031-01-31": "curry",
  "2031-02-01": "rough",
  "2031-02-02": "tabby",
  "2031-02-03": "fever",
  "2031-02-04": "event",
  "2031-02-05": "abate",
  "2031-02-06": "flirt",
  "2031-02-07": "brash",
  "2031-02-08": "vixen",
  "2031-02-09": "basin",
  "2031-02-10": "apple",
  "2031-02-11": "howdy",
  "2031-02-12": "payee",
  "2031-02-13": "plant",
  "2031-02-14": "snack",
  "2031-02-15": "alike",
  "2031-02-16": "dying",
  "2031-02-17": "grove",
  "2031-02-18": "gamma",
  "2031-02-19": "bushy",
  "2031-02-20": "soapy",
  "2031-02-21": "jazzy",
  "2031-02-22": "hound",
  "2031-02-23": "hairy",
  "2031-02-24": "chain",
  "2031-02-25": "wrung",
  "2031-02-26": "snide",
  "2031-02-27": "hence",
  "2031-02-28": "suing",
  "2031-03-01": "dirty",
  "2031-03-02": "aloof",
  "2031-03-03": "bugle",
  "2031-03-04": "angle",
  "2031-03-05": "islet",
  "2031-03-06": "ranch",
  "2031-03-07": "ember",
  "2031-03-08": "civil",
  "2031-03-09": "chore",
  "2031-03-10": "crude",
  "2031-03-11": "brunt",
  "2031-03-12": "harry",
  "2031-03-13": "drama",
  "2031-03-14": "knead",
  "2031-03-15": "angry",
  "2031-03-16": "cheer",
  "2031-03-17": "sonic",
  "2031-03-18": "saint",
  "2031-03-19": "ditto",
  "2031-03-20": "since",
  "2031-03-21": "bench",
  "2031-03-22": "whisk",
  "2031-03-23": "tweed",
  "2031-03-24": "bingo",
  "2031-03-25": "pivot",
  "2031-03-26": "organ",
  "2031-03-27": "truss",
  "2031-03-28": "taker",
  "2031-03-29": "elfin",
  "2031-03-30": "bleat",
  "2031-03-31": "borne",
  "2031-04-01": "creek",
  "2031-04-02": "arise",
  "2031-04-03": "mecca",
  "2031-04-04": "group",
  "2031-04-05": "brute",
  "2031-04-06": "creep",
  "2031-04-07": "wreck",
  "2031-04-08": "geeky",
  "2031-04-09": "dingy",
  "2031-04-10": "shoot",
  "2031-04-11": "tapir",
  "2031-04-12": "pygmy",
  "2031-04-13": "woken",
  "2031-04-14": "octal",
  "2031-04-15": "doubt",
  "2031-04-16": "tonal",
  "2031-04-17": "badly",
  "2031-04-18": "wrist",
  "2031-04-19": "outer",
  "2031-04-20": "vinyl",
  "2031-04-21": "modal",
  "2031-04-22": "yearn",
  "2031-04-23": "spoon",
  "2031-04-24": "china",
  "2031-04-25": "bigot",
  "2031-04-26": "irony",
  "2031-04-27": "vista",
  "2031-04-28": "mamma",
  "2031-04-29": "amuse",
  "2031-04-30": "homer",
  "2031-05-01": "credo",
  "2031-05-02": "blare",
  "2031-05-03": "condo",
  "2031-05-04": "latte",
  "2031-05-05": "flesh",
  "2031-05-06": "wooly",
  "2031-05-07": "women",
  "2031-05-08": "kiosk",
  "2031-05-09": "hilly",
  "2031-05-10": "cloak",
  "2031-05-11": "whoop",
  "2031-05-12": "masse",
  "2031-05-13": "ozone",
  "2031-05-14": "graze",
  "2031-05-15": "moody",
  "2031-05-16": "scour",
  "2031-05-17": "rally",
  "2031-05-18": "hunky",
  "2031-05-19": "krill",
  "2031-05-20": "miser",
  "2031-05-21": "helix",
  "2031-05-22": "crack",
  "2031-05-23": "humid",
  "2031-05-24": "mealy",
  "2031-05-25": "terra",
  "2031-05-26": "verso",
  "2031-05-27": "board",
  "2031-05-28": "chafe",
  "2031-05-29": "swing",
  "2031-05-30": "allow",
  "2031-05-31": "space",
  "2031-06-01": "leggy",
  "2031-06-02": "ethos",
  "2031-06-03": "bleed",
  "2031-06-04": "slept",
  "2031-06-05": "hotel",
  "2031-06-06": "tulle",
  "2031-06-07": "razor",
  "2031-06-08": "three",
  "2031-06-09": "logic",
  "2031-06-10": "dairy",
  "2031-06-11": "split",
  "2031-06-12": "retch",
  "2031-06-13": "kayak",
  "2031-06-14": "sprig",
  "2031-06-15": "squib",
  "2031-06-16": "rehab",
  "2031-06-17": "plunk",
  "2031-06-18": "given",
  "2031-06-19": "doing",
  "2031-06-20": "cabin",
  "2031-06-21": "world",
  "2031-06-22": "gayer",
  "2031-06-23": "moist",
  "2031-06-24": "gauze",
  "2031-06-25": "knave",
  "2031-06-26": "stunt",
  "2031-06-27": "horny",
  "2031-06-28": "shoal",
  "2031-06-29": "might",
  "2031-06-30": "award",
  "2031-07-01": "shell",
  "2031-07-02": "radio",
  "2031-07-03": "ninja",
  "2031-07-04": "flint",
  "2031-07-05": "hasty",
  "2031-07-06": "elder",
  "2031-07-07": "titan",
  "2031-07-08": "pinky",
  "2031-07-09": "scant",
  "2031-07-10": "skate",
  "2031-07-11": "freak",
  "2031-07-12": "offer",
  "2031-07-13": "scone",
  "2031-07-14": "amiss",
  "2031-07-15": "piece",
  "2031-07-16": "newly",
  "2031-07-17": "under",
  "2031-07-18": "gruel",
  "2031-07-19": "heavy",
  "2031-07-20": "maize",
  "2031-07-21": "cycle",
  "2031-07-22": "spend",
  "2031-07-23": "bravo",
  "2031-07-24": "miner",
  "2031-07-25": "tract",
  "2031-07-26": "prune",
  "2031-07-27": "mouth",
  "2031-07-28": "zonal",
  "2031-07-29": "river",
  "2031-07-30": "thong",
  "2031-07-31": "snaky",
  "2031-08-01": "lever",
  "2031-08-02": "sheet",
  "2031-08-03": "attic",
  "2031-08-04": "spiel",
  "2031-08-05": "alien",
  "2031-08-06": "honey",
  "2031-08-07": "eclat",
  "2031-08-08": "cocoa",
  "2031-08-09": "plump",
  "2031-08-10": "shack",
  "2031-08-11": "fuzzy",
  "2031-08-12": "sheep",
  "2031-08-13": "frail",
  "2031-08-14": "tally",
  "2031-08-15": "godly",
  "2031-08-16": "quark",
  "2031-08-17": "anode",
  "2031-08-18": "clown",
  "2031-08-19": "dandy",
  "2031-08-20": "impel",
  "2031-08-21": "leafy",
  "2031-08-22": "tease",
  "2031-08-23": "pupal",
  "2031-08-24": "large",
  "2031-08-25": "llama",
  "2031-08-26": "swill",
  "2031-08-27": "flaky",
  "2031-08-28": "dully",
  "2031-08-29": "flock",
  "2031-08-30": "sally",
  "2031-08-31": "parse",
  "2031-09-01": "glyph",
  "2031-09-02": "cheat",
  "2031-09-03": "biome",
  "2031-09-04": "madly",
  "2031-09-05": "diary",
  "2031-09-06": "scowl",
  "2031-09-07": "stink",
  "2031-09-08": "prime",
  "2031-09-09": "state",
  "2031-09-10": "lumen",
  "2031-09-11": "forgo",
  "2031-09-12": "stale",
  "2031-09-13": "inlet",
  "2031-09-14": "smoky",
  "2031-09-15": "wiser",
  "2031-09-16": "brave",
  "2031-09-17": "ladle",
  "2031-09-18": "reset",
  "2031-09-19": "spied",
  "2031-09-20": "teary",
  "2031-09-21": "creak",
  "2031-09-22": "cried",
  "2031-09-23": "chase",
  "2031-09-24": "lover",
  "2031-09-25": "kinky",
  "2031-09-26": "today",
  "2031-09-27": "biddy",
  "2031-09-28": "dimly",
  "2031-09-29": "video",
  "2031-09-30": "sugar",
  "2031-10-01": "rhyme",
  "2031-10-02": "cameo",
  "2031-10-03": "fluid",
  "2031-10-04": "amber",
  "2031-10-05": "brace",
  "2031-10-06": "after",
  "2031-10-07": "spent",
  "2031-10-08": "rerun",
  "2031-10-09": "image",
  "2031-10-10": "risen",
  "2031-10-11": "guilt",
  "2031-10-12": "slimy",
  "2031-10-13": "coyly",
  "2031-10-14": "grasp",
  "2031-10-15": "slate",
  "2031-10-16": "shock",
  "2031-10-17": "axial",
  "2031-10-18": "buxom",
  "2031-10-19": "wharf",
  "2031-10-20": "rugby",
  "2031-10-21": "timer",
  "2031-10-22": "exalt",
  "2031-10-23": "piper",
  "2031-10-24": "mafia",
  "2031-10-25": "unify",
  "2031-10-26": "goose",
  "2031-10-27": "brink",
  "2031-10-28": "solve",
  "2031-10-29": "broke",
  "2031-10-30": "flier",
  "2031-10-31": "canal",
  "2031-11-01": "golly",
  "2031-11-02": "dough",
  "2031-11-03": "snare",
  "2031-11-04": "claim",
  "2031-11-05": "warty",
  "2031-11-06": "spell",
  "2031-11-07": "cross",
  "2031-11-08": "altar",
  "2031-11-09": "scare",
  "2031-11-10": "tumor",
  "2031-11-11": "tonic",
  "2031-11-12": "small",
  "2031-11-13": "stack",
  "2031-11-14": "suave",
  "2031-11-15": "moron",
  "2031-11-16": "extol",
  "2031-11-17": "lance",
  "2031-11-18": "deter",
  "2031-11-19": "balmy",
  "2031-11-20": "viola",
  "2031-11-21": "swung",
  "2031-11-22": "sweep",
  "2031-11-23": "flume",
  "2031-11-24": "repay",
  "2031-11-25": "mammy",
  "2031-11-26": "neigh",
  "2031-11-27": "beard",
  "2031-11-28": "gusty",
  "2031-11-29": "belie",
  "2031-11-30": "silly",
  "2031-12-01": "tempo",
  "2031-12-02": "bible",
  "2031-12-03": "recur",
  "2031-12-04": "trite",
  "2031-12-05": "daisy",
  "2031-12-06": "cyber",
  "2031-12-07": "groan",
  "2031-12-08": "mulch",
  "2031-12-09": "barge",
  "2031-12-10": "broth",
  "2031-12-11": "folio",
  "2031-12-12": "vigil",
  "2031-12-13": "shore",
  "2031-12-14": "quiet",
  "2031-12-15": "pasta",
  "2031-12-16": "stung",
  "2031-12-17": "phone",
  "2031-12-18": "store",
  "2031-12-19": "villa",
  "2031-12-20": "south",
  "2031-12-21": "thyme",
  "2031-12-22": "cobra",
  "2031-12-23": "cavil",
  "2031-12-24": "frame",
  "2031-12-25": "stein",
  "2031-12-26": "lunar",
  "2031-12-27": "fruit",
  "2031-12-28": "paste",
  "2031-12-29": "cover",
  "2031-12-30": "undid",
  "2031-12-31": "brain",
  "2032-01-01": "fritz",
  "2032-01-02": "mango",
  "2032-01-03": "scope",
  "2032-01-04": "brick",
  "2032-01-05": "odder",
  "2032-01-06": "input",
  "2032-01-07": "nymph",
  "2032-01-08": "corer",
  "2032-01-09": "foamy",
  "2032-01-10": "chief",
  "2032-01-11": "idler",
  "2032-01-12": "melee",
  "2032-01-13": "admit",
  "2032-01-14": "value",
  "2032-01-15": "teddy",
  "2032-01-16": "shawl",
  "2032-01-17": "haven",
  "2032-01-18": "spicy",
  "2032-01-19": "cabby",
  "2032-01-20": "cedar",
  "2032-01-21": "gulch",
  "2032-01-22": "chute",
  "2032-01-23": "adorn",
  "2032-01-24": "quite",
  "2032-01-25": "fight",
  "2032-01-26": "spice",
  "2032-01-27": "swore",
  "2032-01-28": "token",
  "2032-01-29": "arrow",
  "2032-01-30": "rajah",
  "2032-01-31": "fleet",
  "2032-02-01": "spite",
  "2032-02-02": "avoid",
  "2032-02-03": "prick",
  "2032-02-04": "prong",
  "2032-02-05": "cagey",
  "2032-02-06": "curse",
  "2032-02-07": "amass",
  "2032-02-08": "maker",
  "2032-02-09": "siren",
  "2032-02-10": "adult",
  "2032-02-11": "qualm",
  "2032-02-12": "magic",
  "2032-02-13": "venom",
  "2032-02-14": "dread",
  "2032-02-15": "trail",
  "2032-02-16": "grate",
  "2032-02-17": "toxic",
  "2032-02-18": "heady",
  "2032-02-19": "curvy",
  "2032-02-20": "stoic",
  "2032-02-21": "gaudy",
  "2032-02-22": "alone",
  "2032-02-23": "abyss",
  "2032-02-24": "patch",
  "2032-02-25": "going",
  "2032-02-26": "groom",
  "2032-02-27": "betel",
  "2032-02-28": "vague",
  "2032-02-29": "avail",
  "2032-03-01": "steel",
  "2032-03-02": "trash",
  "2032-03-03": "rhino",
  "2032-03-04": "apart",
  "2032-03-05": "shunt",
  "2032-03-06": "being",
  "2032-03-07": "break",
  "2032-03-08": "delta",
  "2032-03-09": "proof",
  "2032-03-10": "relax",
  "2032-03-11": "berth",
  "2032-03-12": "silky",
  "2032-03-13": "until",
  "2032-03-14": "rapid",
  "2032-03-15": "liner",
  "2032-03-16": "brass",
  "2032-03-17": "enema",
  "2032-03-18": "slick",
  "2032-03-19": "pitch",
  "2032-03-20": "lodge",
  "2032-03-21": "erupt",
  "2032-03-22": "noise",
  "2032-03-23": "snout",
  "2032-03-24": "fifty",
  "2032-03-25": "waver",
  "2032-03-26": "clack",
  "2032-03-27": "urine",
  "2032-03-28": "motto",
  "2032-03-29": "excel",
  "2032-03-30": "coupe",
  "2032-03-31": "foyer",
  "2032-04-01": "outgo",
  "2032-04-02": "tenet",
  "2032-04-03": "oddly",
  "2032-04-04": "worst",
  "2032-04-05": "chirp",
  "2032-04-06": "forum",
  "2032-04-07": "weedy",
  "2032-04-08": "elbow",
  "2032-04-09": "scion",
  "2032-04-10": "first",
  "2032-04-11": "lithe",
  "2032-04-12": "rumba",
  "2032-04-13": "ought",
  "2032-04-14": "quoth",
  "2032-04-15": "power",
  "2032-04-16": "skulk",
  "2032-04-17": "ankle",
  "2032-04-18": "waist",
  "2032-04-19": "moult",
  "2032-04-20": "knack",
  "2032-04-21": "greet",
  "2032-04-22": "whirl",
  "2032-04-23": "spurt",
  "2032-04-24": "humus",
  "2032-04-25": "booth",
};

export default answers;
